'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const RecordTypeModel = require('system/domain/entity/record-type');
const DefaultRecordTypes = require('system/domain/entity/default-record-types');

const RecordTypeStore = Backbone.Model.extend({
    initialize: function() {
        _.bindAll(this, 'dispatch');
        this._contextRecordTypes = new Backbone.Collection();
        Dispatcher.register(this.dispatch);

        _.each(DefaultRecordTypes, function(t) {
            Dispatcher.dispatch({
                type: Actions.CREATE_RECORD_TYPE,
                recordType: t
            });
        });
    },

    _recordTypes: function() {
        return this._contextRecordTypes;
    },

    clearAll: function() {
        this._contextRecordTypes = new Backbone.Collection();
    },

    getRecordTypes: function() {
        return this._recordTypes();
    },

    dispatch: function(action) {
        switch(action.type) {
            case Actions.CREATE_RECORD_TYPE:
                this._createRecordType(action);
                break;
        }
    },

    _createRecordType: function(action) {
        let _recordTypes = this._recordTypes(action.context);
        let recordTypes =[];
        if(!action.recordType) {
            return;
        }
        if(_.isArray(action.recordType)){
            recordTypes = _.map(action.recordType, function(j) {
                return new RecordTypeModel(j);
            });
        } else {
            recordTypes = [new RecordTypeModel(action.recordType)];
        }
        _recordTypes.unshift(recordTypes);
    }
});

module.exports = new RecordTypeStore();



// WEBPACK FOOTER //
// ./system/domain/repository/record-type.js